export default __webpack_public_path__ + "static/media/hand-image-9.3f8438fd.webp";